import Model from "./Model";
import { Profile, Company } from ".";
import AdcontrolProfile from "@/models/AdcontrolProfile";
import { FEATURE_CURRENCY_UNIT } from "@/constants";

export default class User extends Model {
  static type = "users";

  email!: string;
  role!: string;

  profile?: Profile;
  company?: Company;

  adcontrolProfiles?: AdcontrolProfile[];

  get isAdmin(): boolean {
    return this.role == "superadmin" || this.role == "admin";
  }

  get accountCompany(): Company {
    return this.adcontrolProfiles?.[0].accountCompany ?? ({} as Company);
  }

  get isAgencyUser(): boolean {
    return this.profile?.isAgency ?? false;
  }

  get radio(): boolean {
    if (this.profile?.media?.id) {
      return this.profile?.media?.id == "1";
    } else {
      return true;
    }
  }

  get tv(): boolean {
    if (this.profile?.media?.id) {
      return this.profile?.media?.id == "2";
    } else {
      return true;
    }
  }

  get hasEbiquity(): boolean {
    return this.hasFeature(FEATURE_CURRENCY_UNIT);
  }

  hasFeature(feature: string) {
    if (!this.profile) {
      return false;
    }
    return this.profile.hasFeature(feature);
  }
}
